var React = require('react');

function IconThumbupO (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M621.2 390.7H878c44.8 0 81.4 36.6 81.4 81.4v81.4c0 10.6-2 20.3-5.7 29.7l-123 286.9c-12.2 29.3-41.1 49.6-74.9 49.6H389.6c-44.8 0-81.4-36.6-81.4-81.4V431.4c0-22.4 9-42.7 24-57.4L600 105.9l43.1 42.7c11 11 17.9 26.5 17.9 43.1l-1.2 13-38.6 186zm-20.5-201L374.5 416.2l-.6.6c-3.8 3.7-5.9 8.7-5.9 14.6v406.9c0 11.8 9.9 21.7 21.7 21.7h366.2c8.9 0 16.5-5.1 20-13.5l122.2-285.1.1-.2-.1.2c1.1-2.9 1.6-5.3 1.6-8V472c0-11.8-9.9-21.7-21.7-21.7H547.8l14.9-71.8M64.1 919.7V431.4h162.8v488.3H64.1zm0-59.6h162.8l-59.7 59.7V431.5l59.7 59.7H64.1l59.7-59.7v488.3l-59.7-59.7z"}));
}

IconThumbupO.displayName = "IconThumbupO";

IconThumbupO.defaultProps = {"viewBox":"0 0 1024 1024"};

module.exports = IconThumbupO;

IconThumbupO.default = IconThumbupO;
